import React from 'react';
import Slider from 'react-slick';
import { images } from '../../../assets/images'
import { renderImage } from '../../../Components/helper/image';


function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-right"></i>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-left"></i>
        </div>
    );
}

function HomeSlider(props) {
    var settings = {
        autoplay: true,
        dots: false,
        infinite: true,
        speed: 3500,
        slidesToShow: 1,
        slidesToScroll: 1,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />
    };
    return (
        <div className="hero_slider">
            {props.item && props.item.sliders.length > 0 &&<div className="hero_slider_area">
                <Slider {...settings}>
                    {props.item && props.item.sliders.map((item, index) => (
                        <div key={index}>
                            <img src={renderImage(item.image, 'large')} alt="..." className='img-fluid' />
                            <div className='banner_content'>
                                <p>
                                    {item.title}
                                </p>
                            </div>
                        </div>

                    ))}
                </Slider>
            </div>}
        </div>
    );
}

export { HomeSlider };
